import { Radio } from "antd";

import { BaseRadioButtonsGroupProps } from "./types";

import "./styles.css";

const BaseRadioButtonsGroup = ({
  options,
  className,
  ...props
}: BaseRadioButtonsGroupProps) => {
  return (
    <Radio.Group
      className={`base-radio-buttons-group full-width ${className}`}
      options={options}
      {...props}
    />
  );
};

export default BaseRadioButtonsGroup;
